import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";

export default function CutoffDialog({ open, message, onClose }) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberIcon color="warning" />
        {t("Age Cutoff Warning")}
      </DialogTitle>
      <DialogContent dividers>
        <Typography whiteSpace="pre-line" mb={2}>{t('Your child does not meet the Kindergarten age cutoff for the following school(s):')}</Typography>
        <Typography whiteSpace="pre-line">{message}</Typography>
        <Typography whiteSpace="pre-line" mt={2}>{t('Please remove them from your application, to continue.')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="warning">
          {t("OK")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
